import { Box, styled } from '@mui/material'
import { spacing } from '@/styles/designTokens'

export const StyledFormInputsWrapper = styled(Box)({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: `${spacing.lg}px`,
	alignItems: 'flex-start',
})

export const StyledLoadingContent = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: spacing.sm,
	justifyContent: 'center',
})
